exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".aHveB {\n  margin-top: 0 !important;\n  border-top-color: #A0A0A0 !important;\n}\n.aHveB {\n  padding-top: 10px;\n  padding-bottom: 10px;\n  padding-left: 20px;\n  padding-right: 20px;\n  cursor: pointer;\n}\n.aHveB ._2-eXL ._15CbQ {\n  color: #99785C;\n  font-weight: bold;\n  font-size: 18px;\n}\n.aHveB ._2-eXL ._2carP {\n  color: #A0A0A0;\n  font-size: 15px;\n}\n", ""]);

// Exports
exports.locals = {
	"container": "aHveB",
	"details": "_2-eXL",
	"title": "_15CbQ",
	"desc": "_2carP"
};